import { handleOpenChat } from "utils/analytics";

export default function Parallax() {
  return (
    <div className="relative h-80 parallax">
        <img className="object-cover fixed top-0 left-0 w-full h-full" src="/home/02.webp" alt="BarraTour" />
        <div className="flex flex-col items-center p-12 parallax">
            <h3 className="center text-white text-xl">Maragogi é lindo demais</h3>
            <p className="center text-white text-center py-6">
                Águas claras e mornas, ondas calmas, area branquinha, piscinas naturais...<br/><br/> 
                Tudo isso e muito mais tem em um lugar chamado Maragogi
            </p>
            <button onClick={handleOpenChat} className="text-white bg-orange-400 rounded py-2 px-5" type="button">
              Fale Conosco
            </button>
        </div>
    </div>
  )
}